<template>
  <div class="scene">Сахна / Сцена</div>
</template>

<script>
export default {
  name: "Section6"
}
</script>

<style scoped lang="scss">
.scene {
  position: absolute;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background: #ddd;
  width: 750px;
  height: 350px;
  top: 30px; 
  left: 300px;
}
</style>
